import { useState, useEffect, SetStateAction, useContext, useRef } from "react";
import { Swd_func } from "../../../api/app/swd_func";
// import { Census_func } from "../../../api/devices/census_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Tooltip, Body2, Badge, ProgressBar, Spinner } from "@fluentui/react-components";
import { AddSquare20Regular, Filter20Filled, FilterDismiss20Filled, SlideEraser20Regular, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, BookTemplate20Regular, BoxCheckmark20Regular, CheckboxCheckedSync20Regular, PulseSquare20Regular, ShieldLock20Regular, SquareHintApps20Regular, Dismiss16Regular, AppsList20Regular, AppsListDetail20Filled, ArrowUpload20Regular, Open20Regular, Delete20Regular, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { Form } from "@rjsf/fluent-ui";
import React from "react";
import { CustomWidgets } from '../../../components/form-components';
import validator from '@rjsf/validator-ajv8';
//////////////////////////////////////////////////////////
import { GlobalContext } from "../../../hooks/globalContext";
import DialogBox from "../../../components/dialog/dialog.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { Activity_log_func } from "../../../api/activity_log/activity_log_func";
import { primaryIcon, secondaryIcon, lightTheme, overflowDivider, buttonContent, dividerWidthStyle, DynamicBoxingCSS, heightResponsive, parentHome, wraperStyle, SubSectionResponsive, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { useLocation } from "react-router-dom";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import * as XLSX from 'xlsx';
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { AutomateAppPages } from "../../../components/side_menu/InlineSidenav";

interface PackageGroup {
  id: number;
  name: string;
  rows: any[];
}
declare module 'json-schema' {
  export interface JSONSchema7 {
    enumNames?: Array<string>;
  }
}
// Define required column structures
const REQUIRED_FIRST_SHEET_COLUMNS = [
  'ID',
  'App PackageID',
  'Names',
  'Description',
  'Version',
  'Operating System',
  'Status',
  'Path',
  'Application Name'
];

const REQUIRED_SECOND_SHEET_COLUMNS = [
  'ID',
  'formDataAdv',
  'formDataApp',
  'formDataPkg',
  'Config32bit',
  'Config64bit',
  'edConfig'
];

// Configuration constants
const CONFIG = {
  MAX_FILE_SIZE_MB: 5,
  MAX_ROWS_PER_SHEET: 10000,
  CHUNK_SIZE: 1000,
  MAX_COLUMN_COUNT: 20
};

interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export const Appinstallation = () => {
  const location = useLocation();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const handle = useFullScreenHandle();
  var tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
  const [final_data, set_final_data]: any = useState([]);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [rowID, setRowID]: any = useState(null);
  const [rowconfID, setRowconfID]: any = useState(null);
  const [installationOverLayData, setInstallationOverLayData]: any = useState([]);
  const [tracker, setTracker] = useState(false);
  const [userActivityData, setUserActivityData] = useState({});
  const [searchVal, setSearchVal] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportConfigData, setExportConfigData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [exportConfigDetails, setExportConfigDetails]: any = useState([]);
  const [isdeletedisabled, setDeleteDisabled] = useState(false);
  const [itemArr, setItemArr]: any = useState([]);
  const [remDiv, setRemDiv]: any = useState(2);
  const [preCheck, setPreCheck] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectUpload, setUpload] = useState('existing');
  const [selectCommon, setCommon] = useState('');
  const [savePackageDetails, setSavePackageDetails] = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [isCommonToast, setIsCommonToast] = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [jsonSchemaPkg, setJsonDataPkg]: any = useState({});
  const [uiSchemaPkg, setUiDataPkg]: any = useState({});
  const [jsonSchemaApp, setJsonDataApp]: any = useState({});
  const [uiSchemaApp, setUiDataApp]: any = useState({});
  const [jsonSchemaAdv, setJsonDataAdv]: any = useState({});
  const [uiSchemaAdv, setUiDataAdv]: any = useState({});
  const [formDataUser, setFormDataUser] = useState(null);
  const [isDelete, setDelete] = useState(false)
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  // const [permissions,setPermissions] = useState([''])
  const { permissions } = usePermissionStore();
  const [type, setType] = useState('Installation');
  const [loading, setLoading] = useState(true);
  const [uniqueOS, setUniqueOS] = useState([]);
  const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
  const [uniqueVersion, setUniqueVersion] = useState<string[]>([]);

  const [isOsName, setOsName] = useState([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [versionOptions, setVersionOptions] = useState<any[]>([]);

  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);

  const [overlayOpenNew, setOverlayOpenNew] = useState(false);
  const [overLayDataNew, setOverLayDataNew] = useState<any>({});
  const [csvConfigurationList, setcsvConfigurationList] = useState<(string | number)[][]>([]);
  const [csvPackageConfigurationList, setcsvPackageConfigurationList] = useState<(string | number)[][]>([]);
  const [selectedFile, setSelectedFile] = useState<any>();
  const [dataInserted, setDataInserted] = useState<any>(false);
  const [selectedValue, setSelectedValue] = useState(0);
  const [isSubTableSelect, setIsSubTableSelect] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);

  // const [formDataPkg, setFormDataPkg] = React.useState(null);
  const [formDataPkg, setFormDataPkg]: any = React.useState({});
  const [formDataApp, setFormDataApp]: any = React.useState({});
  const [formDataAdv, setFormDataAdv]: any = React.useState({});

  const [isProgressLoading, setIsProgressLoading] = useState(false);
  const [isImportProgressLoading, setIsImportProgressLoading] = useState(false);
  const [importSubmitClicked, setImportSubmitClicked] = useState(false);

  const [message, setMessage] = useState<{ type: 'success' | 'error' | 'warning' | ''; text: string } | null>(null);
  console.log("App installtion FORMDATA", formDataAdv)
  useEffect(() => {
  }, [csvPackageConfigurationList, csvConfigurationList]);

  console.log("jsonSchemaApp", jsonSchemaApp);
  useEffect(() => {
    setOsName(uniqueOS?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setStatusOptions(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setVersionOptions(uniqueVersion?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
  }, [uniqueOS, uniqueStatus, uniqueVersion]);

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    const regexN = /^[0-9\.]*$/;
    if (name === 'filter' && dropDownValue1 === ("Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Version")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    // if (name === 'filter' && dropDownValue1 === ("Status")) {
    //   if (regexS.test(enteredValue)) {
    //     setDropDownValue2(enteredValue);
    //     }
    // } 
    if (name === 'filter' && dropDownValue1 === ("Description")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  // call the save package here
  const saveBtnFunc = () => {
    setSavePackageDetails(true)
    setIsToast(true)
    setOverlayOpen(false)
  }

  const handleEditData = (data: any) => {
    const pkgDetails = JSON.parse(data[0]?.formDataPkg)
    const appDetail = JSON.parse(data[0]?.formDataApp)
    const advDetail = JSON.parse(data[0]?.formDataAdv)
    setFormDataPkg(pkgDetails)
    setFormDataApp(appDetail);
    setFormDataAdv(advDetail);
  }

  const [deleteprofile, setDeleteprofile]: any = useState(false);
  const [deleteId, SetDeleteId]: any = useState([]);

  // logic for clone form starts here
  interface FormItem {
    id: number;
    data: {};
  }

  const [cloneForms, setCloneForms] = useState<FormItem[]>([]);

  const handleAddClone = () => {
    if (cloneForms?.length < 3) {
      setCloneForms([...cloneForms, { id: Date.now(), data: {} }]);

    }

  };
  const handleRemoveClone = (id: any) => {
    setCloneForms(cloneForms.filter((form) => form.id !== id));
  };

  //will remove later after checking
  const handleOptionChange = (value: any) => {
    var optionValue = value.target.value;
    setSelectedOption(optionValue);

    if (optionValue === 'yes' && cloneForms?.length != 4) {
      handleAddClone();
      setSelectedOption('');
    }
    else {
      setSelectedOption('no');
    }
  }

  useEffect(() => {
    if (overlayOpen) {
      const element = document.getElementById("fluent-default-layer-host");
      if (element) {
        element.style.zIndex = '9999999';
      }
      // const elements = document.querySelectorAll('[id*="_title"]');
      // elements.forEach(elementa => {
      //   (elementa as HTMLElement).style.fontSize = '20px';
      // });
    } else {
      setRowID(null);
    }
  }, [overlayOpen])
  //logic for clone form end here

  const handleCommon = (value: any) => {
    var commonOption = value.target.value;
    setCommon(commonOption);
  }

  const handleUpload = (value: any) => {
    var uploadOption = value.target.value;
    setUpload(uploadOption);
  }

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  }
  const handleFilterValueSelect = (event: { target: { value: Event; }; }): void => {
    alert(event.target.value);
  }
  const handleCloseFilter = (index: any): any => {
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const humnaReadableFormat = moment().format('MMMM Do YYYY, h:mm:ss a');

  // Modify the export function to handle potential empty datasets
  let exportToExcel = async () => {
    try {
      const wb = XLSX.utils.book_new();

      // Add App Install Profile sheet
      if (exportData.length > 0) {
        const ws1 = XLSX.utils.json_to_sheet(exportData);
        XLSX.utils.book_append_sheet(wb, ws1, "App Install Profile");
      }

      // Add Configuration Data sheet
      if (exportConfigData.length > 0) {
        const ws2 = XLSX.utils.json_to_sheet(exportConfigData);
        XLSX.utils.book_append_sheet(wb, ws2, "Configuration Data");
      }

      // Only write file if at least one sheet is added
      if (wb.SheetNames.length > 0) {

        setIsProgressLoading(false);
        XLSX.writeFile(wb, `app_install_profile_${tenantName}_${humnaReadableFormat}.xlsx`);
        setExportBtnClicked(false);
        setTimeout(() => {
          setExportData([]);
          setExportConfigData([]);
        }, 1000);
      } else {
        setIsProgressLoading(false);
        // Optionally handle case where no data is available
        console.warn('No data available for export');
      }
    } catch (error) {
      setIsProgressLoading(false);
      setExportBtnClicked(false);
      setTimeout(() => {
        setExportData([]);
        setExportConfigData([]);
      }, 1000);
      console.error('Export to Excel failed:', error);
    }
  };

  const visibility = ["/automate/apps/appinstallation", "/automate/apps/appuninstallprofile", "/automate/apps/appprotectionpolicies", "/automate/apps/appmonitored"].includes(location.pathname);

  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.apps?.App_Installation.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "modified_on_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.apps?.App_Installation.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "apps", page: "App_Installation" });
  }, [contextValue.tableColumnsData]);

  //data table column name code ends here

  // overflow set contents code starts here
  const ActionButton = ({ icon, text, onClick, disabled = false, tooltip }) => (
    tooltip ? (
      <Tooltip content={tooltip} relationship={"description"}>
        <Button shape="circular" appearance="subtle" size="small" onClick={onClick} disabled={disabled}>
          <Stack tokens={{ childrenGap: 5 }} horizontal>
            <StackItem>{icon}</StackItem>
            <StackItem><Caption1>{text}</Caption1></StackItem>
          </Stack>
        </Button>
      </Tooltip>
    ) : (
      <Button shape="circular" appearance="subtle" size="small" onClick={onClick} disabled={disabled}>
        <Stack tokens={{ childrenGap: 5 }} horizontal>
          <StackItem>{icon}</StackItem>
          <StackItem><Caption1>{text}</Caption1></StackItem>
        </Stack>
      </Button>
    )
  );
  var overFlowComponent = {
    data:
      <>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <StackItem>
            {permissions.includes("all") || permissions?.includes("appInstallation_Fullaccess") ? (
              <ActionButton
                icon={loading ?
                  <AddSquare20Regular {...secondaryIcon} />
                  : <AddSquare20Regular {...primaryIcon} />}
                text="Create App Install Profile"
                onClick={() => { setOverlayOpen(true); setOverlayName('addInstallation'); }}
                tooltip={undefined}
                disabled={loading} />
            ) : (
              <ActionButton
                icon={<AddSquare20Regular {...secondaryIcon} />}
                text="Create App Install Profile"
                onClick={undefined}
                tooltip="You do not have access" />
            )}
          </StackItem>
          <StackItem><Divider vertical /></StackItem>
          <StackItem>
            <DialogBox
              headerButton={
                <ActionButton
                  icon={<Delete20Regular {...(isdeletedisabled ? primaryIcon : secondaryIcon)} />}
                  text="Delete"
                  onClick={() => { }}
                  disabled={!isdeletedisabled} tooltip={undefined} />
              }
              content="Kindly verify your intent to delete the package."
              footer=
              {
                <>
                  <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <StackItem>
                      <Button shape="circular" appearance="primary" onClick={() => { setDeleteprofile(true); setCurrentPageNo(1); setIsProgressLoading(true); }} size="small">Confirm</Button>
                    </StackItem>
                    <StackItem>
                      <Button shape="circular" size="small">Cancel</Button>
                    </StackItem>
                  </Stack>
                </>
              }
            />
          </StackItem>
          <StackItem> <Divider vertical /> </StackItem>
          <StackItem>
            <ActionButton
              disabled={loading}
              icon={<ArrowClockwise20Regular {...primaryIcon} />}
              text="Refresh"
              onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}
              tooltip={undefined} />
          </StackItem>
          <StackItem>
            {permissions.includes("all") || permissions?.includes("appInstallation_Fullaccess") || permissions?.includes("appInstallation_ReadandExport") ? (
              <>
                {/* <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_appinstallations_list.csv`}></CSVLink> */}
                <ActionButton
                  disabled={loading}
                  icon={loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />}
                  text="Export"
                  onClick={() => { setExportBtnClicked(true); setIsProgressLoading(true); }} tooltip={undefined} />
              </>
            ) : (
              <ActionButton
                icon={<ArrowDownload20Regular {...secondaryIcon} />}
                text="Export"
                disabled
                tooltip="You do not have access" onClick={undefined} />
            )}
          </StackItem>
          <StackItem>
            {permissions.includes("all") || permissions?.includes("appInstallation_Fullaccess") || permissions?.includes("appInstallation_ReadandExport") ? (
              <>
                {/* <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_appinstallations_list.csv`}></CSVLink> */}
                <ActionButton
                  disabled={loading}
                  icon={loading ? <ArrowUpload20Regular {...secondaryIcon} /> : <ArrowUpload20Regular {...primaryIcon} />}
                  text="Import"
                  onClick={() => {
                    setOverlayOpenNew(true)
                    setSelectedValue(0)
                    setcsvConfigurationList([])
                    setcsvPackageConfigurationList([])
                    setDataInserted(false)
                    setMessage({ type: "", text: "" })
                  }} tooltip={undefined} />
              </>
            ) : (
              <ActionButton
                icon={<ArrowUpload20Regular {...secondaryIcon} />}
                text="Import"
                disabled
                tooltip="You do not have access" onClick={undefined} />
            )}
          </StackItem>
          <StackItem>
            <ActionButton
              disabled={loading}
              icon={loading ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />}
              text="Manage View"
              onClick={() => document.getElementById("manageView").click()} tooltip={undefined} />
          </StackItem>
        </Stack>
      </>
  };

  // overflow set contents code ends here
  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];
  
  useEffect(() => {
    const uniqueIds = new Set(); 
    const tempExportData: any[] = [];

    exportDetails?.forEach((val: any) => {
        if (!uniqueIds.has(val.app_packageId)) {
            uniqueIds.add(val.app_packageId);
            tempExportData.push({
                "ID": val.id,
                "App PackageID": val.app_packageId ? val.app_packageId : '',
                "Names": val.packageName ? val.packageName : '',
                "Description": val.packageDesc ? val.packageDesc : '',
                "Version": val.version ? val.version : '',
                "Operating System": val.platform ? val.platform : '',
                // "Created On":  val.creationTime ? convertToExcelFormat(val.creationTime): '',
                // "Modified On": val.lastModified ? convertToExcelFormat(val.lastModified) : '',
                "Status": val.status ? val.status : '',
                "Path": val.path ? val.path : '',
                "Application Name": val.applicationName ? val.applicationName : '',
            });
        }
    });

    setExportData(tempExportData);
}, [exportDetails]);


  useEffect(() => {
    let tempExportConfigData: any = [];
    exportConfigDetails?.length > 0 && exportConfigDetails.map((val: any) => {
      tempExportConfigData.push({
        "ID": val.packageId,
        "formDataAdv": val.formDataAdv ? val.formDataAdv : '',
        "formDataApp": val.formDataApp ? val.formDataApp : '',
        "formDataPkg": val.formDataPkg ? val.formDataPkg : '',
        "Config32bit": val.Config32bit ? val.Config32bit : '',
        "Config64bit": val.Config64bit ? val.Config64bit : '',
        "edConfig": val.edConfig ? val.edConfig : '',
      });
    });
    setExportConfigData(tempExportConfigData);
  }, [exportConfigDetails]);

  useEffect(() => {
    if (exportData.length > 0 && exportConfigData.length > 0) {
      exportToExcel();
    }
  }, [exportConfigData, exportData]);

  useEffect(() => {
    console.log("final_data=", final_data);
    if (Array.isArray(final_data)) {
      const newUniqueOs: any = [];
      const newUniqueStatus: string[] = [];
      const newUniqueVersion: string[] = [];

      final_data.forEach((val: any) => {
        if (newUniqueOs.indexOf(val.platform) === -1) {
          newUniqueOs.push(val.platform); // Add unique OS name
        }
        if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
          newUniqueStatus.push(val.status);
        }
        if (val.version && val.version.trim() !== "-" && !newUniqueStatus.includes(val.version)) {
          newUniqueVersion.push(val.version);
        }
      });
      setUniqueOS(newUniqueOs);
      setUniqueStatus(newUniqueStatus);
      setUniqueVersion(newUniqueVersion)
    } else {
      setUniqueOS([]);
      setUniqueStatus([]);
      setUniqueVersion([]);
    }
  }, [final_data]);


  useEffect(() => {
    // data table values append code starts here
    const uniqueIds: any = new Set(); // Set to store unique app_packageIds
    const updatedTempTableData = final_data !== undefined && final_data !== null && final_data?.length > 0
      ? final_data?.reduce((accumulator: any, val: any, i: any) => {
        if (!uniqueIds.has(val.app_packageId)) {
          uniqueIds.add(val.app_packageId); // Add app_packageId to the set          
          {
            permissions.includes("all") || permissions?.includes("appInstallation_Fullaccess") ?
              accumulator.push({
                id: `${val.id} : ${val.app_packageId}`,
                // names: { label: <Caption1 onClick={(e: any) => { setRowID(val.id); setRowconfID(val.app_packageId); setOverlayOpen(true); setOverlayName('editInstallation'); }}> {val.packageName !== null ? val.packageName : 'N/A'} </Caption1>, id: `${i}` },
                names: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={(e: any) => { setRowID(val.id); setRowconfID(val.app_packageId); setOverlayOpen(true); setOverlayName('editInstallation'); setSpinnerLoad(true); }}> {val.packageName !== null ? val.packageName : 'N/A'} </Button>, id: `${i}` },
                description: { label: <Caption1 > {val.packageDesc != "" ? val.packageDesc : 'N/A'} </Caption1>, status: "" },
                version: { label: <Caption1> {val.version} </Caption1> },
                os: { label: <Caption1> {val.platform} </Caption1> },
                created_on: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertUTCToReadableFormat(val.creationTime) : '-'} </Caption1>, },
                created_on_timezoned: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertToLocalTimezone(val.creationTime, userTimeZone) : '-'} </Caption1>, },
                modified_on: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertUTCToReadableFormat(val.lastModified) : "-"}</Caption1>, },
                modified_on_timezoned: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertToLocalTimezone(val.lastModified, userTimeZone) : "-"}</Caption1>, },
                status: { label: <Caption1> {val.status != null ? "Draft" : "Draft"} </Caption1> },
              })
              :
              accumulator.push({
                checkbox: "hide",
                id: val.app_packageId,
                names: {
                  label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                    <Button shape="circular" id="ButtonHover" appearance="transparent" size="small"> {val.packageName !== null ? val.packageName : 'N/A'} </Button>
                  </Tooltip>, id: `${i}`
                },
                description: { label: <Caption1 > {val.packageDesc != "" ? val.packageDesc : 'N/A'} </Caption1>, status: "" },
                version: { label: <Caption1> {val.version} </Caption1> },
                os: { label: <Caption1> {val.platform} </Caption1> },
                created_on: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertUTCToReadableFormat(val.creationTime) : '-'} </Caption1>, },
                created_on_timezoned: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertToLocalTimezone(val.creationTime, userTimeZone) : '-'} </Caption1>, },
                modified_on: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertUTCToReadableFormat(val.lastModified) : "-"}</Caption1>, },
                modified_on_timezoned: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertToLocalTimezone(val.lastModified, userTimeZone) : "-"}</Caption1>, },
                status: { label: <Caption1> {val.status != null ? "Draft" : "Draft"} </Caption1> },
              })
          }
        }

        setTotalRecords(accumulator?.length)
        return accumulator;
      }, [])
      : [];

    setTableData(updatedTempTableData);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && final_data?.length > 0 && setLoading(false);
      if (isRefresh) {
        console.log("FIRST CALL");
        setIsRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
          setRefreshToast(false);
        }, 3000);
      }
    }, 500);
  }, [final_data, rowID, permissions]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);
  //dropdown data
  var dropdownData = [
    {
      key: "op_1",
      label:
        <Body1Strong
          onClick={() => {
            setSelectedValue(1);
            setIsSubTableSelect(true)
            contextValue.selectedRowIdInTable.length > 0 && contextValue.setSelectedRowIdInTable([]);
          }}
        >
          Choose devices manually
        </Body1Strong>
    },
    { key: "op_2", label: <Body1Strong onClick={() => setSelectedValue(2)}> Upload a CSV containing the Devices </Body1Strong> }
  ];

  function processPackageIds(firstSheetData: any[][]): any[][] {
    // Create a deep copy of the data to avoid mutations
    const processedData = JSON.parse(JSON.stringify(firstSheetData));
    // Get the header row and data rows
    const [headerRow, ...dataRows] = processedData;
    // Find the index of the App PackageID column
    const packageIdIndex = headerRow.findIndex((col: string) => col === "App PackageID");
    const namesIndex = headerRow.findIndex((col: string) => col === "Names");

    if (packageIdIndex === -1 || namesIndex === -1) {
      setError("Required columns 'App PackageID' or 'Names' not found");
    }
    // Group rows by package name to identify related apps
    const packageGroups: { [key: string]: PackageGroup } = {};

    dataRows.forEach((row) => {
      const packageName = row[namesIndex];
      if (!packageGroups[packageName]) {
        packageGroups[packageName] = {
          id: row[0],
          name: packageName,
          rows: []
        };
      }
      packageGroups[packageName].rows.push(row);
    });

    // Generate and assign new UUIDs for each package group
    Object.values(packageGroups).forEach((group) => {
      const newPackageId = uuidv4();
      // Assign the same UUID to all rows in the package
      group.rows.forEach((row) => {
        row[packageIdIndex] = newPackageId;
      });
    });

    // Reconstruct the processed data with headers
    return [headerRow, ...Object.values(packageGroups).flatMap(group => group.rows)];
  }

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    // Reset states
    setSelectedFile(null);
    setError("");
    setSubmitDisabled(true);

    try {
      // Basic file validation
      const fileValidation = validateFile(selectedFile);
      if (!fileValidation.isValid) {
        setError(fileValidation.error || "Invalid file");
        return;
      }

      // Set the file for further processing
      setSelectedFile(selectedFile);

      const reader = new FileReader();
      reader.onload = async (e: ProgressEvent<FileReader>) => {
        if (!e.target?.result) {
          setError("Failed to read the file. Please try again.");
          return;
        }

        try {
          const data = new Uint8Array(e.target.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: "array" });

          // Validate workbook structure
          const workbookValidation = validateWorkbookStructure(workbook);
          if (!workbookValidation.isValid) {
            setError(workbookValidation.error || "Invalid workbook structure");
            return;
          }

          // Extract and process sheets
          const [firstSheetName, secondSheetName] = workbook.SheetNames;
          const firstWorksheet = workbook.Sheets[firstSheetName];
          const secondWorksheet = workbook.Sheets[secondSheetName];

          // Process sheets in chunks to optimize memory usage
          const firstSheetData = await processSheetInChunks(firstWorksheet);
          const secondSheetData = await processSheetInChunks(secondWorksheet);

          // Validate sheet contents
          const sheetValidation = validateSheetContents(firstSheetData, secondSheetData);
          if (!sheetValidation.isValid) {
            setError(sheetValidation.error || "Invalid sheet contents");
            return;
          }

          // Process the data with UUID updates
          const processedFirstSheetData = processPackageIds(firstSheetData);
          const processedSecondSheetData = secondSheetData;

          // Final validation of processed data
          const processedDataValidation = validateProcessedData(
            processedFirstSheetData,
            processedSecondSheetData
          );
          if (!processedDataValidation.isValid) {
            setError(processedDataValidation.error || "Invalid processed data");
            return;
          }
          // Update state variables
          setcsvConfigurationList(processedFirstSheetData);
          setcsvPackageConfigurationList(processedSecondSheetData);
          setSubmitDisabled(false);
        } catch (error) {
          console.error("Error processing the file:", error);
          setError("An error occurred while processing the file. Please try again.");
        }
      };

      reader.onerror = () => {
        setError("Failed to read the file. Please try again.");
      };

      reader.readAsArrayBuffer(selectedFile);

    } catch (error) {
      console.error("Error in file handling:", error);
      setError("An unexpected error occurred. Please try again.");
    }
  };

  // Validation helper functions
  const validateFile = (file: File | undefined): ValidationResult => {
    if (!file) {
      return { isValid: false, error: "No file selected. Please choose a file to upload." };
    }

    // File size validation
    if (file.size > CONFIG.MAX_FILE_SIZE_MB * 1024 * 1024) {
      return {
        isValid: false,
        error: `File size exceeds ${CONFIG.MAX_FILE_SIZE_MB} MB. Please upload a smaller file.`
      };
    }

    // File type validation
    const validExtensions = [".xlsx", ".xls"];
    const validMimeTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    const isValidFileType =
      validExtensions.some((ext) => file.name.toLowerCase().endsWith(ext)) ||
      validMimeTypes.includes(file.type);

    if (!isValidFileType) {
      return {
        isValid: false,
        error: "Invalid file type. Please upload a valid Excel file (.xlsx or .xls)."
      };
    }

    return { isValid: true };
  };

  const validateWorkbookStructure = (workbook: XLSX.WorkBook): ValidationResult => {
    if (!workbook.SheetNames || workbook.SheetNames.length < 2) {
      return { isValid: false, error: "The file must contain at least two sheets." };
    }

    return { isValid: true };
  };

  const validateSheetContents = (
    firstSheetData: any[][],
    secondSheetData: any[][]
  ): ValidationResult => {
    // Check for empty sheets
    if (!firstSheetData.length || firstSheetData.length <= 1) {
      return { isValid: false, error: "The first sheet is empty or contains only headers." };
    }

    if (!secondSheetData.length || secondSheetData.length <= 1) {
      return { isValid: false, error: "The second sheet is empty or contains only headers." };
    }

    // Validate column headers
    const firstSheetHeaders = firstSheetData[0];
    const secondSheetHeaders = secondSheetData[0];

    const missingFirstSheetColumns = REQUIRED_FIRST_SHEET_COLUMNS.filter(
      col => !firstSheetHeaders.includes(col)
    );

    const missingSecondSheetColumns = REQUIRED_SECOND_SHEET_COLUMNS.filter(
      col => !secondSheetHeaders.includes(col)
    );

    if (missingFirstSheetColumns.length > 0) {
      return {
        isValid: false,
        error: `First sheet missing required columns: ${missingFirstSheetColumns.join(", ")}`
      };
    }

    if (missingSecondSheetColumns.length > 0) {
      return {
        isValid: false,
        error: `Second sheet missing required columns: ${missingSecondSheetColumns.join(", ")}`
      };
    }

    // Check for excessive columns
    if (firstSheetHeaders.length > CONFIG.MAX_COLUMN_COUNT ||
      secondSheetHeaders.length > CONFIG.MAX_COLUMN_COUNT) {
      return {
        isValid: false,
        error: `Sheets contain too many columns. Maximum allowed: ${CONFIG.MAX_COLUMN_COUNT}`
      };
    }

    return { isValid: true };
  };

  const validateProcessedData = (
    firstSheetData: any[][],
    secondSheetData: any[][]
  ): ValidationResult => {
    // Extract IDs from both sheets
    const firstSheetIds = new Set(firstSheetData.slice(1).map((row) => String(row[0])));
    const secondSheetIds = new Set(secondSheetData.slice(1).map((row) => String(row[0])));

    // Validate row count
    if (firstSheetData.length > CONFIG.MAX_ROWS_PER_SHEET ||
      secondSheetData.length > CONFIG.MAX_ROWS_PER_SHEET) {
      return {
        isValid: false,
        error: `Sheet exceeds maximum row limit of ${CONFIG.MAX_ROWS_PER_SHEET}`
      };
    }

    // Check for ID consistency
    const missingIds = Array.from(secondSheetIds).filter((id) => !firstSheetIds.has(id));
    if (missingIds.length > 0) {
      return {
        isValid: false,
        error: `Incomplete data: ${missingIds.length} IDs are missing in the first sheet`
      };
    }

    return { isValid: true };
  };

  // Process sheet data in chunks to optimize memory usage
  const processSheetInChunks = async (worksheet: XLSX.Sheet): Promise<any[][]> => {
    const data: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    const processedData: any[][] = [];

    // Process header row
    if (data.length > 0) {
      processedData.push(data[0]);
    }

    // Process remaining rows in chunks
    for (let i = 1; i < data.length; i += CONFIG.CHUNK_SIZE) {
      const chunk = data.slice(i, i + CONFIG.CHUNK_SIZE);
      processedData.push(...chunk);

      // Optional: Add a small delay to prevent blocking the UI
      if (i % (CONFIG.CHUNK_SIZE * 2) === 0) {
        await new Promise(resolve => setTimeout(resolve, 0));
      }
    }

    return processedData;
  };

  useEffect(() => {
    setOverLayDataNew({
      size: "medium",
      isTabs: false,

      headerTitle:
        (
          <>
            <Title3>
              {'Import Configurations'}
            </Title3>
          </>
        ),

      bodyData:
        (
          <>
            <Stack>{isImportProgressLoading && <ProgressBar />}</Stack>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <StackItem grow shrink>
                <Stack tokens={{ childrenGap: 10 }} horizontal>
                  <StackItem grow shrink>
                    <Stack tokens={{ childrenGap: 20 }} horizontalAlign="start">
                      <StackItem>
                        {<>
                          <Stack className={isImportProgressLoading ? 'disabled-opacity' : ''} verticalAlign="center" tokens={{ childrenGap: 10 }}>
                            <Stack tokens={{ childrenGap: 10 }}>
                              <StackItem><Text></Text></StackItem>

                              <StackItem>
                                {/* <StackItem> <Body1> Start by exporting packages list in app install profiles page. </Body1> </StackItem> */}
                                {/* <StackItem> <Body1> You can choose devices from the same site or different ones to create groups. </Body1> </StackItem> */}
                              </StackItem>
                              <StackItem><Text></Text></StackItem>
                              <StackItem> <Body1Strong> Steps to import the packages </Body1Strong> </StackItem>
                              <StackItem>
                                <Body1> 1. Download the file that contains the list of packages </Body1>
                              </StackItem>
                              <Stack>
                                <StackItem> <Body1> 2. check packages in the xlsx. </Body1> </StackItem>
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 15 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    {/* <StackItem>
																		<Stack tokens={{ childrenGap: 5 }} horizontal>
																			<StackItem> <Caption1> Watch the instructional video for guidance </Caption1> </StackItem>
																			<StackItem> <Open20Regular /> </StackItem>
																		</Stack>
																	</StackItem> */}
                                  </Stack>
                                </StackItem>
                              </Stack>
                              <StackItem> <Body1> 3. Upload your .xlsx file </Body1> </StackItem>
                              <StackItem>
                                {/* <FileUploadComponent setDeviceList={setCsvAutomationList} /> */}
                                {/* <Button shape="circular" appearance='secondary' size='small' onClick={handleUpload}> Select a file </Button> */}
                                <input /*style={{"display": "none"}} */ type="file" onChange={handleFileChange} accept='.xlsx' id="fileUpload" />
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                {/* {selectedFile?.length > 0 && <Text> File selected: {selectedFile} </Text>} */}
                                {/* <Button shape="circular" onClick={ handleFileUpload}>Upload</button> */}
                              </StackItem>
                            </Stack>
                          </Stack>
                        </>
                        }
                      </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </StackItem>
            </Stack>
          </>
        ),

      footerData:
        (
          <>
            {
              <Button shape="circular"
                appearance="primary"
                disabled={
                  !selectedFile || Boolean(error) || isSubmitDisabled
                }
                onClick={() => { /*insertAutomationData();*/ setSubmitDisabled(true); setImportSubmitClicked(true); /*setIsProgressLoading(true); setOverlayOpenNew(false);*/ setIsImportProgressLoading(true); }}
              >
                Submit
              </Button>
            }
            {(message?.type === 'success' && !isImportProgressLoading) && (<Badge appearance="ghost" color="success"> <Body2> Packages has been inserted successfully!</Body2> </Badge>)}
            {(importSubmitClicked) && (<Badge appearance="ghost" color="warning"> <Body2> Please wait until import process completes!</Body2> </Badge>)}
          </>
        )
    });
  }, [selectedFile, csvConfigurationList, dataInserted, overlayOpen, error, isImportProgressLoading]);

  useEffect(() => {
    if (!overlayOpenNew) {
      setError('')
      setSubmitDisabled(true); // disable sumbit button when overlay will get closes.
    }
  }, [overlayOpenNew]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
    contextValue.setSelectedRowIdInSubTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable?.length > 0 ? setDeleteDisabled(true) : setDeleteDisabled(false);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    if (!overlayOpen) {
      formDataPkg != undefined && setFormDataPkg(null);
      formDataApp != undefined && setFormDataApp(null);
      formDataAdv != undefined && setFormDataAdv(null);
    }
  }, [overlayOpen])

  useEffect(() => {
    if (jsonSchemaPkg && jsonSchemaApp && jsonSchemaAdv) {
      overlayName == 'addInstallation' && setInstallationOverLayData({
        headerTitle: "Create App Install Profile",
        size: "large",
        isTabs: true,
        tabItems: {

          "Basic Details": <Stack tokens={{ padding: "5px 0px" }}>

            <StackItem>
              <Form ref={formRef}
                formData={formDataPkg}
                schema={jsonSchemaPkg}
                uiSchema={uiSchemaPkg}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataPkg(e.formData)} />
            </StackItem>
          </Stack>,

          "App Configuration": <Stack tokens={{ padding: "5px 0px" }}>
            {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
            <StackItem>
              <Form
                id="appinstallation"
                ref={formRef}
                formData={formDataApp}
                schema={jsonSchemaApp}
                uiSchema={uiSchemaApp}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataApp(e.formData)} />
            </StackItem>
          </Stack>,


          "Advance Configuration":
            <>
              <Stack tokens={{ padding: "5px 0px" }}>
                {/* <StackItem>
                  <FluentProvider theme={messageTheme}>
                    <Card appearance="subtle" size="small">
                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem> <Info20Filled {...primaryIcon} /> </StackItem>
                        <StackItem> <Caption1> Sorem ipsum dolor sit amet, consectetur adipiscing elit. </Caption1>  </StackItem>
                      </Stack>
                    </Card>
                  </FluentProvider>
                </StackItem> */}
                {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
                <Form
                  id="Advance_Configuration"
                  ref={formRef}
                  formData={formDataAdv}
                  schema={jsonSchemaAdv}
                  uiSchema={uiSchemaAdv}
                  validator={validator}
                  widgets={CustomWidgets}
                  onChange={(e) => setFormDataAdv(e.formData)} />
              </Stack>
            </>,

          "Review Data":
            <>
              <Stack>
                {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
                <Stack>
                  {/* <Text as = "h4" >Package Details</Text> */}
                  <Body1Strong>Package Details</Body1Strong>
                  <Form id="appinstallation" disabled={true} formData={formDataPkg} schema={jsonSchemaPkg} uiSchema={uiSchemaPkg} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataPkg(e.formData)} />
                </Stack>
                <Stack>
                  {/* <Text>App Configurations</Text> */}
                  <Body1Strong>App Configurations</Body1Strong>
                  <Form id="appinstallation" disabled={true} formData={formDataApp} schema={jsonSchemaApp} uiSchema={uiSchemaApp} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataApp(e.formData)} />
                </Stack>
                {/* <Text>Advance Configurations</Text> */}
                <Body1Strong>Advance Configurations</Body1Strong>
                <Stack horizontal tokens={{ childrenGap: 157, padding: 5 }}>
                  <Form disabled={true} formData={formDataAdv} schema={jsonSchemaAdv} uiSchema={uiSchemaAdv} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataAdv(e.formData)} />
                </Stack>    </Stack>
            </>
        }
      });


      // Object.keys(formDataPkg)?.length > 0 &&
      overlayName == 'editInstallation' && setInstallationOverLayData({
        headerTitle: "Edit Installation Profile",
        size: "large",
        isTabs: true,
        tabItems: {

          "Basic Details":spinnerLoad?
          <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner/>
          </Stack>
          : <Stack tokens={{ padding: "5px 0px" }}>
            <StackItem>
              <Form formData={formDataPkg}
                schema={jsonSchemaPkg}
                uiSchema={uiSchemaPkg}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataPkg(e.formData)} />
            </StackItem>
          </Stack>,

          "App Configuration": <Stack tokens={{ padding: "5px 0px" }}>
            <StackItem>
              <Form
                id="appinstallation"
                formData={formDataApp}
                schema={jsonSchemaApp}
                uiSchema={uiSchemaApp}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataApp(e.formData)} />
            </StackItem>
          </Stack>,


          "Advance Configuration":
            <>
              <Stack tokens={{ padding: "5px 0px" }}>
                <Form
                  formData={formDataAdv}
                  schema={jsonSchemaAdv}
                  uiSchema={uiSchemaAdv}
                  validator={validator}
                  widgets={CustomWidgets}
                  onChange={(e) => setFormDataAdv(e.formData)} />
              </Stack>
            </>,

          "Review Data":
            <>
              <Stack>
                <Stack>
                  <Body1Strong>Package Details</Body1Strong>
                  <Form id="appinstallation" disabled={true} formData={formDataPkg} schema={jsonSchemaPkg} uiSchema={uiSchemaPkg} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataPkg(e.formData)} />
                </Stack>
                <Stack>
                  <Body1Strong>App Configurations</Body1Strong>
                  <Form id="appinstallation" disabled={true} formData={formDataApp} schema={jsonSchemaApp} uiSchema={uiSchemaApp} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataApp(e.formData)} />
                </Stack>
                <Body1Strong>Advance Configurations</Body1Strong>
                <Stack horizontal tokens={{ childrenGap: 157, padding: 5 }}>
                  <Form disabled={true} formData={formDataAdv} schema={jsonSchemaAdv} uiSchema={uiSchemaAdv} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataAdv(e.formData)} />
                </Stack>
              </Stack>
            </>
        },
      });
    }
  }, [overlayName, formDataPkg, formDataApp, formDataAdv]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
                      { name: "Automate", link: "/home" },
                      { name: "Apps", link: "/automate/apps/appmonitored" },
                      { name: "App Install Profile", link: "#" }
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
            <StackItem grow shrink>
              <Stack horizontalAlign="end">
                <StackItem grow shrink>
                  <FullScreenButton handle={handle} />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomateAppPages("App Install Profiles")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack>{isProgressLoading && <ProgressBar />}</Stack>
                    <Stack style={DynamicBoxingCSS} className={isProgressLoading ? 'disabled-opacity' : ''} verticalAlign="center" tokens={{ childrenGap: 10 }}>
                      <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                        <StackItem>
                          <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                          <Divider />
                        </StackItem>
                        <StackItem style={wraperStyle}>
                          <StackItem>
                            <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                              <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <StackItem>
                                  <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                </StackItem>
                                <StackItem>
                                  <MenuDropdown open={filterMenuOpen} btn={
                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                    <Divider />
                                    <MenuList>
                                      <Stack tokens={{ childrenGap: 5 }}>
                                        <StackItem> <Text></Text> </StackItem>
                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                        <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                        <StackItem> <Divider /> </StackItem>
                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                        {dropDownValue1 === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                        {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                        {(dropDownValue1 === "Name" || dropDownValue1 === "Description") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                        {dropDownValue1 === "Status" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={statusOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                        {dropDownValue1 === "Version" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={versionOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                        <StackItem> <Divider /> </StackItem>
                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                          <StackItem>
                                            <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                              disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                              <Caption1> Apply </Caption1>
                                            </Button>
                                          </StackItem>

                                          <StackItem>
                                            <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                              <Caption1> Cancel </Caption1>
                                            </Button>
                                          </StackItem>
                                        </Stack>
                                      </Stack>
                                    </MenuList>
                                  </>} />
                                </StackItem>
                                <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                  <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> <FilterDismiss20Filled /> </StackItem>
                                      <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                    </Stack>
                                  </Button>
                                </StackItem>
                              </Stack>
                              {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                            </Stack>
                            <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                              <StackItem>
                                {filterArray.length > 0 &&
                                  // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                  <Stack wrap horizontal >
                                    {filterArray.length > 0 && filterArray.map((item, index) => (
                                      <Button shape="circular" size="small">
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                          <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                          <StackItem>
                                            <Stack tokens={{ childrenGap: 1 }}>
                                              <StackItem><Text></Text></StackItem>
                                              <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                            </Stack>
                                          </StackItem>
                                        </Stack>
                                      </Button>
                                    ))}
                                    {/* </Stack> */}
                                  </Stack>}
                              </StackItem>

                              <StackItem disableShrink>
                                {(tableData.length > 0 && !loading) && (
                                  totalRecords > 0 &&
                                  <Caption1>
                                    Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                  </Caption1>
                                )}
                              </StackItem>
                            </Stack>
                          </StackItem>
                          {/* <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack> */}
                          <InfoBar showSpaces={true} title={"The App Install section allows users to configure applications that can be deployed to devices."} />

                        </StackItem >
                        <Swd_func filterArray={filterArray} data={final_data}
                          func={set_final_data}
                          searchVal={searchVal}
                          pageNo={(currentPageNo - 1) * 50}
                          setTotalPages={setTotalPages}
                          setTotalRecords={setTotalRecords}
                          isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2}
                          savePackageDetails={savePackageDetails}
                          setSavePackageDetails={setSavePackageDetails}
                          setDeleteDisabled={setDeleteDisabled}
                          deleteprofile={deleteprofile}
                          setDeleteprofile={setDeleteprofile}
                          pkgId={deleteId}
                          setJsonDataPkg={setJsonDataPkg}
                          setUiDataPkg={setUiDataPkg}
                          setJsonDataApp={setJsonDataApp}
                          setUiDataApp={setUiDataApp}
                          setJsonDataAdv={setJsonDataAdv}
                          setUiDataAdv={setUiDataAdv}
                          formDataPkg={formDataPkg}
                          formDataApp={formDataApp}
                          formDataAdv={formDataAdv}
                          setFormDataPkg={setFormDataPkg}
                          setFormDataApp={setFormDataApp}
                          setFormDataAdv={setFormDataAdv}
                          rowID={rowID}
                          setRowconfID={setRowconfID}
                          rowconfID={rowconfID}
                          overlayName={overlayName}
                          handleEditData={handleEditData}
                          overlayOpen={overlayOpen}
                          setOverlayOpen={setOverlayOpen}
                          setRowId={setRowID}
                          isRefresh={isRefresh}
                          setIsRefresh={setIsRefresh}
                          setRefreshToast={setRefreshToast}
                          isDelete={isDelete}
                          setDelete={setDelete}
                          setExportDetails={setExportDetails}
                          setExportConfigDetails={setExportConfigDetails}
                          type={type}
                          exportBtnClicked={exportBtnClicked}
                          setExportBtnClicked={setExportBtnClicked}
                          importSubmitClicked={importSubmitClicked}
                          setImportSubmitClicked={setImportSubmitClicked}
                          csvConfigurationList={csvConfigurationList}
                          csvPackageConfigurationList={csvPackageConfigurationList}
                          setIsImportProgressLoading={setIsImportProgressLoading}
                          setIsProgressLoading={setIsProgressLoading}
                          setOverlayOpenNew={setOverlayOpenNew}
                          setMessage={setMessage}
                          setIsCommonToast={setIsCommonToast}
                          setLoading={setLoading}
                          setSpinnerLoad= {setSpinnerLoad}
                        />
                        {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                        {tracker && <Activity_log_func data={userActivityData} setTracker={setTracker} type="insertLog" />}
                      </Stack>
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={installationOverLayData}
              saveBtnFunc={saveBtnFunc}
              isNavBtn={true}
              formRef={formRef}
            />
            {/* {savePackageDetails && <ToastComponent  setMess  toastIntent="success" position="top-end" title="Success" message="Package  Details have been saved Successfully" footer="" /> }   */}
            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"Package Saved Successfully"} footer="" />}
            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
            {/* {deleteprofile && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Deleted Successfully'} footer="" />} */}

            <OverLay
              overlayopen={overlayOpenNew}
              setOverlayOpen={setOverlayOpenNew}
              overlayData={overLayDataNew}
            />
            {isCommonToast && (
              <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent={message?.type} position="top-end" title={message?.type.charAt(0).toUpperCase() + message?.type.slice(1)} message={message?.text} footer="" />
            )}
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};